/* eslint-disable spaced-comment */
import React, { useState, useEffect } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import './SingleParticipantView.css';
import { useVideoTrack } from '@daily-co/daily-react';
import Tile from '../Tile/Tile';
import { selectedParticipantIdState, teacherScreenViewState } from '../../state/viewModeAtom';
import { useMinScreen } from '../hooks/useMinScreen';
import { Close } from '../Tray/Icons';
import { regularParticipantsIdState } from '../../state/participantAtom';

function SingleParticipantView() {
  const [singleParticipantIdState, setSingleParticipantIdState] = useRecoilState(
    selectedParticipantIdState,
  );
  const [regularParticipantsIds] = useRecoilState(regularParticipantsIdState);
  const setViewMode = useSetRecoilState(teacherScreenViewState);

  const videoState = useVideoTrack(singleParticipantIdState);
  const [participantCamera, setParticipantCamera] = useState(!videoState?.isOff);
  const { min } = useMinScreen();

  useEffect(() => {
    setParticipantCamera(!videoState?.isOff);
  }, [videoState?.isOff]);

  const hideCamera = () => {
    setParticipantCamera(false);
  };

  const currentIndex = regularParticipantsIds.findIndex((_id) => _id === singleParticipantIdState);

  const handleToPrevious = () => {
    if (currentIndex <= 0) {
      setViewMode((prev) => (prev === 'single' ? 'grid' : 'call'));
      setSingleParticipantIdState(null);
      return;
    }
    setSingleParticipantIdState(regularParticipantsIds[currentIndex - 1]);
  };

  const handleToNext = () => {
    if (currentIndex >= regularParticipantsIds.length - 1) {
      setViewMode((prev) => (prev === 'single' ? 'grid' : 'call'));
      setSingleParticipantIdState(null);
      return;
    }
    setSingleParticipantIdState(regularParticipantsIds[currentIndex + 1]);
  };

  const handleExit = () => {
    setViewMode((prev) => (prev === 'single' ? 'grid' : 'call'));
    setSingleParticipantIdState(null);
  };

  const canNavigate = regularParticipantsIds.length > 1;
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === regularParticipantsIds.length - 1;

  return (
    <div className="single-screen-wrapper">
      <button type="button" className="exit-participant-view-button" onClick={handleExit}>
        X
      </button>
      {canNavigate && !isFirst && (
        <button type="button" className="centered-arrow left" onClick={handleToPrevious}>
          ◀
        </button>
      )}
      <div className="single-screen-container">
        <div className="single-screen-view">
          {min('lg') && participantCamera && (
            <div className="single-camera-view">
              <button type="button" className="button hide-camera" onClick={hideCamera}>
                <Close />
              </button>
              <div className="single-camera">
                <Tile id={singleParticipantIdState} />
              </div>
            </div>
          )}
          <Tile id={singleParticipantIdState} isScreenShare />
        </div>
      </div>
      {canNavigate && !isLast && (
        <button type="button" className="centered-arrow right" onClick={handleToNext}>
          ▶
        </button>
      )}
    </div>
  );
}

export default SingleParticipantView;
